import { Box, Wrap, WrapItem } from "@chakra-ui/react";
import { Check } from "../../../shared/icons";
import { VINCULO_COLORS, vinculoColorToken } from "../utils/vinculoColors";

// Seletor de cor por amostras (grupo de rádio acessível). `value` vazio = nenhuma
// escolhida (no cadastro, o backend atribui a próxima cor livre).
export default function VinculoColorPicker({ value, onChange, ...rest }) {
  return (
    <Wrap spacing={2} role="radiogroup" aria-label="Cor do vínculo" {...rest}>
      {VINCULO_COLORS.map((color) => {
        const selected = value === color.key;
        return (
          <WrapItem key={color.key}>
            <Box
              as="button"
              type="button"
              role="radio"
              aria-checked={selected}
              aria-label={color.label}
              title={color.label}
              onClick={() => onChange(color.key)}
              boxSize="28px"
              borderRadius="full"
              bg={vinculoColorToken(color.key)}
              color="app-card"
              display="inline-flex"
              alignItems="center"
              justifyContent="center"
              outline="2px solid"
              outlineColor={selected ? "app-fg" : "transparent"}
              outlineOffset="2px"
              _focusVisible={{ boxShadow: "outline" }}
            >
              {selected ? <Check size={14} aria-hidden /> : null}
            </Box>
          </WrapItem>
        );
      })}
    </Wrap>
  );
}
